module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.load
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', _vm._l((_vm.files), function(file) {
    return _c('li', {
      key: file.name
    }, [_vm._v("\n      " + _vm._s(file.filename) + ": "), _c('a', {
      attrs: {
        "href": _vm.filePath(file.filepath),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.filePath(file.filepath)))]), _vm._v(" "), _c('button', {
      staticClass: "delete is-medium",
      on: {
        "click": function($event) {
          return _vm.del(file.filename)
        }
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cecf6fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files.vue
// module id = 1003
// module chunks = 0